import styled from "styled-components";


export const Bar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`